import { MaxIdTypeEnum } from './types';
import type { MaxIds } from './types';

export const MAX_IDS: MaxIds = {
  [MaxIdTypeEnum.FontManipulation]: 0,
  [MaxIdTypeEnum.ImageManipulation]: 0,
  [MaxIdTypeEnum.PositionalAnomaly]: 0,
  [MaxIdTypeEnum.SemanticAnomaly]: 0
};
